import { ErrorHandler, Injectable, inject } from '@angular/core';

import { PostHogService } from './posthog.service';

@Injectable({ providedIn: 'root' })
export class PostHogErrorHandler implements ErrorHandler {
  private readonly posthogService = inject(PostHogService);

  handleError(error: unknown): void {
    this.posthogService.posthog?.captureException(error);
    console.error(error);
  }
}
